import type { FunctionComponent, MutableRefObject } from 'react';

import { Form, FormTheme } from '@kanda-libs/ks-component-ts';
import {
  Button,
  Loader,
  ModalContainer,
  ModalLayoutCenter,
  Text,
} from '@kanda-libs/ks-design-library';

import LenderConfigRow from './LenderConfigRow';
import { MODAL_ID } from './constants';
import useEditLenderConfig from './useEditLenderConfig';

const EditLenderConfigModalForm: FunctionComponent<{
  handleClose: () => void;
  innerRef?: MutableRefObject<HTMLElement | undefined>;
}> = function ({ handleClose, innerRef }) {
  const {
    form,
    fields,
    configs,
    addLender,
    deleteLender,
    onSubmit,
    isSubmitting,
  } = useEditLenderConfig(handleClose);

  return (
    <>
      <ModalLayoutCenter
        id="staff-edit-lender-config"
        onClose={handleClose}
        ref={innerRef as MutableRefObject<HTMLDivElement>}
        className="w-10/12 p-4 md:w-160"
      >
        <FormTheme variant="streamline">
          <Form
            id="staff-edit-lender-config"
            form={form}
            onSubmit={onSubmit}
            className="flex w-full flex-col"
          >
            <Text
              text="Lender configs"
              className="mb-4 text-20-24-em text-neutral-900"
            />

            {fields.length === 0 ? (
              <Text
                text="No lender configs"
                className="py-2 text-14-22 text-neutral-500"
              />
            ) : (
              fields.map((field, index) => (
                <LenderConfigRow
                  key={field.id}
                  index={index}
                  isNew={field.isNew}
                  configs={configs}
                  onDelete={deleteLender}
                />
              ))
            )}

            <Button.Text
              id="staff-edit-lender-config-add"
              label="Add lender"
              onClick={addLender}
              variant="outline"
              className="mr-auto mt-4"
            />

            <Button.Text
              id="staff-edit-lender-config-submit"
              submit
              disabled={isSubmitting}
              label="Save lender configs"
              className="mx-auto mt-6"
            />
          </Form>
        </FormTheme>
      </ModalLayoutCenter>
      <Loader isLoading={isSubmitting} />
    </>
  );
};

const EditLenderConfigModal: FunctionComponent = function () {
  return (
    <ModalContainer id={MODAL_ID} opacity={30}>
      {({ handleClose, ref }) => (
        <EditLenderConfigModalForm handleClose={handleClose} innerRef={ref} />
      )}
    </ModalContainer>
  );
};

export default EditLenderConfigModal;
